export default {
    setImpuestosArray(state,i){
        state.impuestosArray = i;
    }
}